module.exports = __webpack_public_path__ + "static/media/safari_logo.8f59d1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/safari_logo.png
// module id = 1307
// module chunks = 37